import React from 'react';

const Component = props => {
	return (
		<>
			<div className='my-[50px]'>
				<h2 className='text-[30px] md:text-[25px] font-normal mb-[30px] text-[#282e3f]'>
					Présentation personnelle
				</h2>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Maître Hugue RADELET a entamé son cursus universitaire à l'Unamur et a, ensuite, poursuivi son
					master au sein de l'Université Catholique de Louvain. Il est inscrit au Barreau de Charleroi depuis
					2021.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Jeune avocat dynamique et engagé, Maître Hugue RADELET se distingue par sa volonté de défendre avec
					détermination les intérêts de ses clients, notamment en matière de roulage et dans le domaine du
					droit des assurances ainsi que devant le tribunal correctionnel. Passionné par ces matières, il met
					un point d'honneur à garantir une défense solide et rigoureuse.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Actuellement, il effectue un certificat universitaire en droit des assurances afin de perfectionner
					sa connaissance du cadre législatif et réglementaire en la matière.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Maître Hugue RADELET exerce essentiellement au sein du Cabinet GAVA-<i>Lex</i> à Charleroi où il
					accueille l'ensemble de ses clients avec un souci constant de confiance et de proximité.
				</p>
			</div>
		</>
	);
};

export default Component;
